export enum Target {
  BLANK='_blank',
  SELF='_self'
}
